import React,{useEffect} from 'react';
import {
    trackAdditionalPageView
} from "../../common/util/ccAnalyticsV2";
import '../../common/css/global.css';
import '../../common/css/ImpactPage.css'
import ImpactDashboard from "../../common/components/impact/ImpactDashboard";

const ImpactPage = ({merchantCode}) => {
    useEffect(() => {
            //trackAdditionalPageView('/impact',['aviation','customer'])
    }, []
    );

    return (
        <>
            <ImpactDashboard merchantCode={merchantCode} />
        </>
    )
};

export default ImpactPage;